import React, { useEffect } from 'react'
import { GoogleMap } from '@react-google-maps/api'
import { useGoogleMap } from 'hooks/useGoogleMap'
import { StoresMapProps } from './StoresMap.types'

export const StoresMapClusterIconStyles = [
  {
    url: '/images/icons/cluster-icon.svg',
    width: 32,
    height: 32,
    textColor: 'transparent',
  },
]

export const StoresMapRtmClusterIconStyles = [
  {
    url: '/images/icons/rtm_cluster_icon.svg',
    width: 32,
    height: 32,
    textColor: 'transparent',
  },
]

export const StoresMapMarkerIconStyle = {
  url: '/images/icons/map-icon-circle.svg',
  width: 32,
  height: 32,
}

export const StoresResellerMapMarkerIconStyle = {
  url: '/images/icons/map-icon-circle-reseller.svg',
  width: 32,
  height: 32,
}

export const StoresMapRtmMarkerIconStyle = {
  url: '/images/icons/rtm_map_icon_circle.svg',
  width: 32,
  height: 32,
}

export const StoreDetailsMapMarkerIconStyle = {
  url: '/images/icons/map-icon.svg',
  width: 32,
  height: 32,
}

export const StoreDetailsRtmMapMarkerIconStyle = {
  url: '/images/icons/rtm_map_icon.svg',
  width: 32,
  height: 32,
}

export const StoresMap = ({
  center,
  initialZoom,
  options,
  onLoadedMap,
  onBoundsChanged,
  children,
}: StoresMapProps) => {
  const { apiLoaded, mapProps, map } = useGoogleMap(center)

  const mapOptions: google.maps.MapOptions = {
    mapId: process.env.NEXT_PUBLIC_GOOGLE_MAP_ID || null,
    zoomControl: false,
    streetViewControl: false,
    scrollwheel: true,
    fullscreenControl: false,
    mapTypeControl: false,
    ...options,
  }

  useEffect(() => {
    if (map && onLoadedMap) {
      onLoadedMap(map)
    }
  }, [map, onLoadedMap])

  const handleBoundsChanged = () => {
    if (!map) {
      return
    }
    onBoundsChanged?.(map)
  }

  return (
    <div className='w-full h-full rounded-md overflow-hidden'>
      {apiLoaded && (
        <GoogleMap
          mapContainerClassName='w-full h-full'
          onBoundsChanged={handleBoundsChanged}
          zoom={initialZoom}
          options={mapOptions}
          {...mapProps}>
          {children}
        </GoogleMap>
      )}
    </div>
  )
}
